// extracted by mini-css-extract-plugin
module.exports = {"tiny":"LegendItemStats_tiny__1uDU5","dotted":"LegendItemStats_dotted___8i2x","fixedWidth":"LegendItemStats_fixedWidth__1nbzD"};